import { useLocation, useRoutes } from 'react-router-dom';
// ==============================|| ROUTING RENDER ||============================== //
import MainRoutes from './MainRoutes';

export default function ThemeRoutes() {
    let routes = useRoutes(MainRoutes);
    return routes;
}
